<template>
  <v-dialog :value="value" max-width="720" @input="$emit('input', $event)">
    <v-card>
      <v-toolbar color="primary" dark flat dense>
        <v-toolbar-title>{{ $t("reports.farmProductivity.guideTitle") }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="pt-5">
        <!-- Steps 1-3 -->
        <div v-if="step < 3">
          <v-img
            :src="`/assets/ai-report-guide/farm-productivity/step-${step + 1}.png`"
            class="mb-4"
            style="width: 100%"
            contain
          />
          <div class="grey--text mb-1">
            {{ $t("reports.farmProductivity.guideStep", { current: step + 1, total: 3 }) }}
          </div>
          <h3 class="primary--text mb-3">{{ $t(`reports.farmProductivity.guideStep${step + 1}Title`) }}</h3>
          <p class="body-2 pre-line black--text">{{ $t(`reports.farmProductivity.guideStep${step + 1}Body`) }}</p>
        </div>

        <!-- Final tip screen -->
        <div v-else>
          <h3 class="black--text mb-2">{{ $t("reports.farmProductivity.guideTip") }}</h3>
          <p class="body-2 pre-line black--text">{{ $t("reports.farmProductivity.guideTipBody") }}</p>
        </div>
      </v-card-text>

      <v-card-actions class="pb-4 px-4">
        <v-spacer />
        <v-btn v-if="step > 0" outlined color="primary" @click="step -= 1">
          {{ $t("reports.farmProductivity.back") }}
        </v-btn>
        <v-btn outlined color="primary" @click="close">{{ $t("reports.farmProductivity.close") }}</v-btn>
        <v-btn v-if="step < 3" color="primary" depressed @click="step += 1">
          {{ $t("reports.farmProductivity.next") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "FarmProductivityGuideDialog",
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    return {
      step: 0,
    };
  },
  watch: {
    value(open) {
      if (open) this.step = 0;
    },
  },
  methods: {
    close() {
      this.$emit("input", false);
    },
  },
};
</script>

<style scoped>
.pre-line {
  white-space: pre-line;
}
</style>
